
<style>
  .form-material select, .form-material input, .form-material textarea, languageSelector select {
    width: 100%;
    font-size:14px;
  }

.form-material select {
  font-size:14px;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.languageContainer {
  display:block;
  margin-bottom:10px;
}

.globalContainer {
  display:block;
  margin-bottom:10px;
  padding:12px;
}

textarea {min-height: 100px;}

</style>

<app-modal-header [headerTitle]="'Edit Lectionary Item Type'" (languageSelected)="setSelectedLanguage($event)"></app-modal-header>


<div class="globalContainer" *ngIf="item != null && listsLoaded == true">

    <div *ngIf="CurrentLocalizedData() != null" style="border-bottom:1px solid gray">
        {{currentLanguage.Name}}
    </div>

    <div *ngIf="CurrentLocalizedData() != null" class="languageContainer">

        <div class="form-group row">

          <div class="col-8">
            <div class="form-material">
                <input matInput [(ngModel)]="CurrentLocalizedData().Name">
                <label for="">Name</label>
            </div>
        </div>
  

        <div class="col-12">
            <div class="form-material">
                <textarea matInput [(ngModel)]="CurrentLocalizedData().Description"></textarea>
                <label for="">Description</label>
            </div>
        </div>

        </div>

    </div>

    <div  style="border-bottom:1px solid gray">All Languages</div>

    <div class="form-group row">


      <div class="col-6">
        <div class="form-material">

            <select [ngModel]="item.ReligionBranch?.Id"  (ngModelChange)="item.ReligionBranch = setModelValue($event, item.ReligionBranch)">
                <option *ngFor="let section of religionBranches" [ngValue]="section.Id">
                    {{section.Name}}
                </option>
              </select>

            <label for="">Religion Branch</label>

        </div>
    </div>

    <div class="col-6">
      <div class="form-material">

        <select [(ngModel)]="item.DesignatedLectionaryItemType">
          <option></option>
          <option value=1>About This Service</option>
          <option value=2>Background</option>
          <option value=3>Collect</option>
          <option value=4>First Reading</option>
          <option value=5>Gospel</option>
          <option value=6>Poem</option>
          <option value=7>Proper Preface</option>
          <option value=8>Psalm</option>
          <option value=9>Second Reading</option>
          <option value=10>Synopsis</option> 
        </select>

          <label for="">Designated Lectionary Item Type</label>

      </div>
  </div> 

  </div>

</div>


<div mat-dialog-actions class="float-right">
<button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
<button mat-button (click)="save()"   class="btn btn-sm btn-outline-primary">Save</button>

</div>
